import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";

function RedirectLogin({ open,handleClose }) {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/account");
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle className="d-flex justify-content-between align-items-center">
          <h5 className="m-0">Please login to add cart</h5>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className="ml-auto"
          >
            <CancelIcon />
          </IconButton>
        </DialogTitle>

        <DialogActions sx={{ justifyContent: "center", alignItems: "center" }}>
          <Button onClick={handleLogin} variant="contained">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default RedirectLogin;
